import React from "react";
import { SectionHeader } from "./ui/SectionHeader";
export function Certificate() {
  return <section className="w-full bg-[#142FA8] py-10 md:py-16" data-id="element-50" data-mp="2xdz94lieqzb7">
      <div className="container mx-auto px-4 md:px-6 max-w-[1120px]" data-id="element-51" data-mp="2xbd16krluhsg">
        <SectionHeader theme="dark" title={<>CERTIFICADO DE <span className="text-[#FFC900]" data-id="element-53" data-mp="2nfa3ps7p77bu">FINALIZACIÓN</span></>} subtitle="Sumá tu formación a tu perfil profesional" className="mb-8 md:mb-10" data-id="element-52" data-mp="2ihgv6sixa18e" />

        <div className="max-w-4xl mx-auto" data-id="element-54" data-mp="3b65nc2202w80">
          <div className="bg-white p-3 md:p-6 rounded-[20px] shadow-2xl mb-6 border-4 border-white/20" data-id="element-55" data-mp="3g3xs3wnquctm">
            <img src="https://cdn.magicpatterns.com/uploads/pr8nLZGB3m4pgKzSTwhHvk/ChatGPT_Image_8_ago_2026,_20_39_35.webp" alt="Certificado Mecánico Industrial PRO" className="w-full h-auto rounded-[12px] shadow-sm border border-gray-200" data-id="element-56" data-mp="31f1ab7vvxlft" />
          </div>
          
          <p className="text-center text-white/90 text-[14px] md:text-[16px] max-w-2xl mx-auto font-[500] leading-[1.5]" data-id="element-57" data-mp="3u2dytnllw3br">
            El certificado acredita la finalización del material de formación y puede utilizarse como complemento de tu perfil profesional.
          </p>
        </div>
      </div>
    </section>;
}